import { Controller } from "@hotwired/stimulus"

// Generic confirm-delete modal.
//
// Usage:
//   <div data-controller="confirm-delete">
//     <button data-action="click->confirm-delete#open"
//             data-confirm-delete-url-param="/things/42"
//             data-confirm-delete-name-param="My thing">Delete</button>
//
//     <div data-confirm-delete-target="modal" class="hidden ...">
//       <form data-confirm-delete-target="form" method="post">
//         <input type="hidden" name="_method" value="delete">
//         <input type="hidden" name="authenticity_token" value="<%= form_authenticity_token %>">
//         You are about to delete <span data-confirm-delete-target="name"></span>.
//         <button type="button" data-action="click->confirm-delete#close">Cancel</button>
//         <button type="submit">Delete</button>
//       </form>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["modal", "form", "name"]

  open(event) {
    const url = event.params.url
    const name = event.params.name
    if (url) this.formTarget.action = url
    if (this.hasNameTarget) this.nameTarget.textContent = name || ""
    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
